/** Display helpers for Chores & Events chatbot cards. */

export function formatChoresEventsDate(value, opts = { year: 'numeric', month: 'long', day: 'numeric' }) {
    if (!value) return '—';
    try {
        const raw = String(value);
        const d = raw.includes('T') ? new Date(raw) : new Date(`${raw}T00:00:00`);
        if (Number.isNaN(d.getTime())) return raw;
        return d.toLocaleDateString('en-US', opts);
    } catch {
        return String(value);
    }
}

export function formatChoresEventsShortDate(value) {
    return formatChoresEventsDate(value, { year: 'numeric', month: 'short', day: 'numeric' });
}

export function formatChoresEventsTime(value) {
    if (!value) return '—';
    try {
        const [h, m] = String(value).split(':').map(Number);
        if (Number.isNaN(h)) return String(value);
        const ap = h >= 12 ? 'PM' : 'AM';
        return `${h % 12 || 12}:${String(m || 0).padStart(2, '0')} ${ap}`;
    } catch {
        return String(value);
    }
}

export function choreStatusColor(status) {
    const k = String(status || '').toLowerCase();
    if (k === 'completed') return '#16a34a';
    if (k === 'skipped') return '#dc2626';
    return '#d97706';
}

export function eventRsvpColor(status) {
    const k = String(status || '').toLowerCase();
    if (k === 'attending') return '#16a34a';
    if (k === 'declined') return '#dc2626';
    return '#d97706';
}

export function joinNames(list) {
    if (!Array.isArray(list) || !list.length) return '—';
    return list.filter(Boolean).join(', ') || '—';
}

export function buildEventAddress(detail = {}) {
    return [detail.addressLine1, detail.addressLine2, detail.city, detail.stateName, detail.zip]
        .filter(Boolean)
        .join(', ') || '—';
}
